// import { Component } from '@angular/core';

// @Component({
//   selector: 'app-privacy-policy',
//   standalone:true,
//   imports: [],
//   templateUrl: './privacy-policy.html',
//   styleUrl: './privacy-policy.css',
// })
// export class PrivacyPolicy {

// }
import { Component, OnInit, PLATFORM_ID, inject, signal } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';

interface PrivacyItem {
  ID: number;
  Title: string;
  Content: string;       // HTML
  DisplayOrder: number;
}

@Component({
  selector: 'app-privacy-policy',
  standalone: true,
  imports: [],
  templateUrl: './privacy-policy.html',
  styleUrl: './privacy-policy.css',
})
export class PrivacyPolicy implements OnInit {
  private http = inject(HttpClient);
  private platformId = inject(PLATFORM_ID);

  private readonly apiBase = 'https://crm-api.redmonkwellness.com';

  sections = signal<PrivacyItem[]>([]);
  loading = signal(true);
  error = signal(false);

  ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) return;   // API call only in the browser

    this.http
      .post<{ success: boolean; Items: PrivacyItem[] }>(
        `${this.apiBase}/TimelessMonk/GetPrivacy`,
        {}
      )
      .subscribe({
        next: (res) => {
          if (res.success) this.sections.set(res.Items || []);
          else this.error.set(true);
          this.loading.set(false);
        },
        error: (err) => {
          console.error('Privacy load failed:', err);
          this.error.set(true);
          this.loading.set(false);
        },
      });
  }
}